import './ActiveIndicator.scss';
import classNames from 'classnames';
import React from 'react';
import { Tooltip } from 'antd';
import { isNull, isUndefined } from '@sonar-software/sonar-ts-lib';
export const ActiveIndicator = ({ isActive }) => {
    if (isUndefined(isActive) || isNull(isActive)) {
        return null;
    }
    const value = Boolean(isActive);
    const title = value ? 'Active' : 'Inactive';
    const innerClasses = classNames('active-indicator-inner', { active: value });
    return (React.createElement("div", { className: 'active-indicator' },
        React.createElement(Tooltip, { arrow: { pointAtCenter: true }, autoAdjustOverflow: true, overlayStyle: {
                maxWidth: 400,
                width: 'auto'
            }, placement: 'top', title: title },
            React.createElement("div", { className: innerClasses }))));
};
